import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Flex, theme } from "antd";
import ReportHeader from "../../component/ReportHeader";

import StyledContainer from "./style";

import { getChartPieData } from "../../helper";

import { ReactComponent as Demo } from "./image/demo.svg";

const ReportPageProposalHowToGet = ({
  personaName,
  productsList,
  proposalData,
}) => {
  const { token } = theme.useToken();

  const financialProductData = productsList?.find(
    it => it._id === proposalData?.productId
  );

  return (
    <StyledContainer id="reportPageProposalHowToGet">
      <Flex className="page-container" gap={46} vertical>
        <ReportHeader personaName={personaName} />

        <article style={{ width: 581 }}>
          <h4>How do we get there?</h4>
          <p>
            The BX platform is engineered with a two-fold investment process
            designed to support dynamic, personalized portfolio construction.
          </p>
        </article>

        <article>
          <Flex justify="space-between">
            <Flex flex="0 0 355px" vertical>
              <p style={{ marginTop: 0 }}>
                <b>First</b>, our manager selection process identifies asset
                managers with clearly defined strengths, niche specializations,
                and a demonstrated ability to deliver forward-looking,
                risk-adjusted value. This selection is not based on past
                performance alone, but on the firm’s ongoing investment
                commitment, strategic clarity, and process sustainability.
              </p>
              <p>
                <b>Second</b>, our strategy inclusion framework rigorously
                filters and aligns each manager’s capabilities with investable
                offerings across four core categories: equity and fixed income,
                international and domestic holdings, factor-based strategies,
                and solutions that are risk-managed or alpha-seeking. This
                curated universe of investment building blocks can be configured
                into customized solutions or used as standalone exposures
                allowing advisors and institutions to construct portfolios that
                are both tailored and responsive. At BX, this structured yet
                flexible approach ensures that investor outcomes are powered by
                quality, specialization, and adaptability across all market
                environments.
              </p>
            </Flex>

            <Demo />
          </Flex>
        </article>

        <article>
          <div
            style={{
              borderBottom: "1px solid #C9C8C8",
              fontSize: 23,
              marginBottom: 24,
              paddingBottom: 16,
            }}
          >
            <span>Selected Investment Product:</span>
            <h4>{financialProductData?.name ?? financialProductData?.Name}</h4>
          </div>

          <Flex justify="space-between">
            <Flex flex="0 0 413px">
              <p>
                {financialProductData?.objective ??
                  financialProductData?.Description}
              </p>
            </Flex>

            <HighchartsReact
              highcharts={Highcharts}
              options={{
                chart: {
                  backgroundColor: "rgba(219, 242, 242, 0.40)",
                  height: 176,
                  spacing: [16, 16, 16, 16],
                  type: "pie",
                  width: 535,
                },
                tooltip: {
                  outside: true,
                  style: {
                    zIndex: 9999,
                  },
                },
                title: {
                  text: null,
                },
                credits: {
                  enabled: false,
                },
                plotOptions: {
                  pie: {
                    size: 146,
                    innerSize: "60%",
                    showInLegend: true,
                    center: ["50%", "50%"],
                    borderColor: "#ffffff",
                    borderWidth: 2,
                    dataLabels: {
                      enabled: false,
                    },
                  },
                },
                legend: {
                  enabled: true,
                  align: "right",
                  verticalAlign: "middle",
                  borderWidth: 0,
                  labelFormatter: function () {
                    return `<div style="width:245px; white-space: normal;">${
                      this.y + "% " + this.name
                    }</div>`;
                  },
                  itemStyle: {
                    fontSize: 14,
                  },
                },
                exporting: {
                  buttons: {
                    contextButton: {
                      enabled: false,
                    },
                  },
                },
                colors: token.chart_colors,
                series: [
                  {
                    colorByPoint: true,
                    data: getChartPieData(financialProductData),
                    name: "Selected",
                    size: "100%",
                  },
                ],
              }}
            />
          </Flex>
        </article>
      </Flex>
    </StyledContainer>
  );
};

export default ReportPageProposalHowToGet;
